import {
    IEditAreaCanvasSizeManager,
    IEditAreaCanvasSize,
    IEditAreaCanvasSizeProps,
} from '@src/slide/application/service/edit-area-canvas-size-manager/edit-area-canvas-size-manager.interface';
import { observable, transaction } from 'mobx';

/**
 * 编辑区画布尺寸管理
 */
export default class EditAreaCanvasSizeManager implements IEditAreaCanvasSizeManager {
    @observable private canvasWidth = 0;
    @observable private canvasHeight = 0;
    @observable private slideLeft = 0;
    @observable private slideTop = 0;
    @observable private scale = 1;
    @observable private isAutoAdapter = true;

    public getCanvasSize(): IEditAreaCanvasSize {
        return {
            canvasWidth: this.canvasWidth,
            canvasHeight: this.canvasHeight,
            slideLeft: this.slideLeft,
            slideTop: this.slideTop,
            scale: this.scale,
        };
    }

    public getCanvasScale(): number {
        return this.scale;
    }

    public getCanvasIsAutoAdapter(): boolean {
        return this.isAutoAdapter;
    }

    public setCanvasSize(canvasSize: IEditAreaCanvasSizeProps): void {
        const props = {
            canvasWidth: this.canvasWidth,
            canvasHeight: this.canvasHeight,
            slideLeft: this.slideLeft,
            slideTop: this.slideTop,
            scale: this.scale,
        };
        Object.assign(props, canvasSize);

        transaction(() => {
            this.canvasWidth = props.canvasWidth;
            this.canvasHeight = props.canvasHeight;
            this.slideLeft = props.slideLeft;
            this.slideTop = props.slideTop;
            this.scale = props.scale;
        });
    }

    public setCanvasScale(scale: number): void {
        this.scale = scale;
    }

    public setIsAutoAdapter(isAutoAdapter: boolean): void {
        this.isAutoAdapter = isAutoAdapter;
    }

    public setCanvasScaleAndIsAutoAdapter(scale: number, isAutoAdapter: boolean): void {
        transaction(() => {
            this.scale = scale;
            this.isAutoAdapter = isAutoAdapter;
        });
    }
}
